import * as React from 'react';
export const BDSvg = React.forwardRef(function BDSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#159570',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        fillRule: 'nonzero',
        d: 'M7 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z',
      }),
    ),
  );
});
BDSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var BD = {
  category: 'flag',
  colorable: false,
  name: 'BD',
  svg: BDSvg,
};
